@if (label) {
    <span class = "ui-label">
        {{ label }}
    </span>
}
<div class = "ui-quantity-selector-container">
    <div class = "ui-field ui-secondary">
        @if (withControl) {
            <button [disabled] = "value === 1" class = "ui-button ui-quantity-control-left" (click) = "eventControlClicked(-1)">
                <i class = "uii-minus-alt"></i>
            </button>
            <button [disabled] = "value === 100" class = "ui-button ui-quantity-control-right" (click) = "eventControlClicked(1)">
                <i class = "uii-plus-alt"></i>
            </button>
        }

        <input type="text" [mask]="mask" [suffix]="suffix" (change) = "eventChanged($event)" [ngModel] = "value" [allowNegativeNumbers] = "allowNegative"/>
    </div>
</div>
